@if (ts.tasks().length > 0) {
  <div class="dl-toast" [class.dl-toast--collapsed]="!ts.expanded()">

    <!-- ── Header (always visible) ── -->
    <div class="dl-toast__header" (click)="toggleExpand()">
      <div class="dl-toast__title">
        <!-- Download icon -->
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
        <span>Downloads</span>
        <span class="dl-toast__badge">{{ ts.tasks().length }}</span>
        @if (ts.activeCount() > 0) {
          <span class="dl-toast__spinner">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
              style="animation: dl-spin 0.8s linear infinite">
              <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0" stroke-opacity="0.25"/>
              <path d="M12 3a9 9 0 0 1 9 9"/>
            </svg>
          </span>
        }
      </div>
      <div class="dl-toast__header-right">
        @if (ts.doneOrFailedCount() > 0) {
          <button class="dl-toast__clear-btn" (click)="clearCompleted($event)" title="Dismiss finished items">
            Clear done
          </button>
        }
        <span class="dl-toast__chevron" [class.dl-toast__chevron--up]="ts.expanded()">
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="18 15 12 9 6 15"/>
          </svg>
        </span>
      </div>
    </div>

    <!-- ── Body (collapsible) ── -->
    @if (ts.expanded()) {
      <div class="dl-toast__body">
        @for (task of ts.tasks(); track task.requestId) {
          <div class="dl-toast__item" [class]="'dl-toast__item--' + task.status">

            <!-- Status icon -->
            <div class="dl-toast__item-icon">
              @switch (task.status) {
                @case ('queued') {
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                    style="animation: dl-spin 0.8s linear infinite">
                    <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0" stroke-opacity="0.25"/>
                    <path d="M12 3a9 9 0 0 1 9 9"/>
                  </svg>
                }
                @case ('downloading') {
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                    style="animation: dl-spin 0.8s linear infinite">
                    <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0" stroke-opacity="0.25"/>
                    <path d="M12 3a9 9 0 0 1 9 9"/>
                  </svg>
                }
                @case ('done') {
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                }
                @case ('failed') {
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                }
              }
            </div>

            <!-- Task info -->
            <div class="dl-toast__item-body">
              <div class="dl-toast__item-ref" [title]="task.batchRef">{{ task.batchRef }}</div>
              <div class="dl-toast__item-status-text">{{ statusLabel(task) }}</div>
            </div>

            <!-- Dismiss (only for completed states) -->
            @if (task.status === 'done' || task.status === 'failed') {
              <button class="dl-toast__item-dismiss" (click)="remove(task.requestId)" title="Dismiss">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <line x1="18" y1="6" x2="6" y2="18"/>
                  <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            }
          </div>
        }
      </div>
    }

  </div>
}
